// extracted by mini-css-extract-plugin
module.exports = {"modal":"EntityFormModal_modal__3TMeT","header":"EntityFormModal_header__14oeA"};